export default __webpack_public_path__ + "static/media/sticker-z.83dbfcfe.png";